/**
 * Where a memo is filed.
 *
 * A memo is an editorial-info assignment at newsvalue 1 whatever its template,
 * so the newsvalue is a rule about what a memo is rather than a per-template
 * setting, and the creation dialog offers no way to change it.
 *
 * The section is the same rule for every template that covers the whole desk,
 * and those are filed in Inrikes. A template written per section says so with
 * `sectionChoice: 'select'` and the dialog asks the editor instead, and one
 * that always belongs to one section names it with `filingSection`.
 *
 * The section is a title rather than a uuid, since section uuids differ between
 * environments; it is resolved against the sections the datastore knows about.
 * An environment without a matching section blocks memo creation instead of
 * failing at the backend.
 */
export const MEMO_SECTION_TITLE = 'Inrikes'
export const MEMO_NEWSVALUE = '1'
